import { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { Card, StatusPill, Tabs } from '../../../ui'
import { CaseDetailsView } from '../subViews/caseDetailsView'
import { MilestonesView } from '../subViews/milestonesView'
import { FilesView } from '../subViews/filesView'
import { ActionsView } from '../subViews/actionsView'
import { CourtDatesView } from '../subViews/courtDatesView'
export interface statsProps {
    data: any
}
export const CaseView = (props: statsProps) => {
    const { data } = props
    const [showView, setShowView] = useState('details')
    const [activeCase, setActiveCase] = useState(data)

    useEffect(() => {
        setActiveCase(data)
    }, [data])

    if (!data) {
        return null
    }

    const views: any = {
        details: <CaseDetailsView data={activeCase} />,
        milestones: <MilestonesView data={activeCase} />,
        files: <FilesView caseRef={activeCase.case_ref} />,
        actions: (
            <ActionsView
                caseRef={activeCase.case_ref}
                hasPoc={data.hasPoc}
                pocLink={data.hasPocLink ? data.pocPortalLink : ''}
                cancelledStatus={data.cancelled}
                part36={{ sf: data.settlement_figure, cn: data.court_claim_number, ds: data.defendant_solicitor }}
            />
        ),
    }

    const selectView = (view: string) => {
        setShowView(view)
    }

    const getCurrentView = () => {
        return views[showView]
    }

    const flagOn = (v: unknown) => v === 1 || v === '1' || v === true

    const caseState = (dupe: unknown, cancelled: unknown) => {
        if (flagOn(dupe)) {
            return 'Duplicate'
        }
        if (flagOn(cancelled)) {
            return 'Cancelled'
        }
        return 'Active'
    }

    const tabItems = [
        { value: 'details', label: 'Details' },
        { value: 'milestones', label: 'Milestones' },
        // { value: 'courtDates', label: 'Court' },
        { value: 'files', label: 'Files' },
        { value: 'actions', label: 'Actions' },
    ]

    const state = caseState(activeCase.marked_duplicate, activeCase.cancelled)
    const tone = state === 'Active' ? 'good' : state === 'Cancelled' ? 'bad' : 'warn'

    return (
        <Card className={styles.caseView} padding="none">
            <div className={styles.caseHeader}>
                <h3 className={styles.caseTitle}>
                    Case reference <span className={styles.caseRef}>{activeCase.case_ref}</span>
                </h3>
                <StatusPill tone={tone} dot>
                    {state}
                </StatusPill>
            </div>
            <Tabs items={tabItems} value={showView} onChange={(v) => selectView(v)} inCard noMargin />
            <div className={styles.outerCaseView}>{getCurrentView()}</div>
        </Card>
    )
}
